import type { PublishedLegalDocument } from "./content-types.ts"

export const SERVICE_TERMS = {
  announcedAt: "2026-07-30",
  effectiveAt: "2026-07-30",
  preamble: [],
  publishable: true,
  sections: [
    {
      title: "제1조 목적",
      blocks: [{ kind: "paragraph", text: "이 약관은 주식회사 아인아이엔씨(이하 “회사”)가 제공하는 CashHub 웹사이트, 모바일 웹, 모바일 애플리케이션 및 이에 부수하는 서비스의 이용과 관련하여 회사와 회원의 권리·의무, 책임 및 서비스 이용조건을 정하는 것을 목적으로 한다." }],
    },
    {
      title: "제2조 회사 정보",
      blocks: [
        {
          kind: "ordered-list",
          items: ["서비스명: CashHub", "법인명: 주식회사 아인아이엔씨(Ayin Inc.)", "대표자: 김성훈", "사업자등록번호: 361-87-03107", "사업장 주소: 경기도 성남시 판교로255번길 9-22 417호", "이메일: mediavue02@gmail.com", "고객지원 연락처: 010-7386-9363", "고객지원: CashHub 로그인 후 1:1 문의 및 위 연락처"],
        },
      ],
    },
    {
      title: "제3조 용어의 정의",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "“서비스”란 회원이 제휴 서비스의 리워드를 CashHub 통합잔액으로 전환하고, 통합잔액을 사용하여 회사가 제공하는 상품 또는 혜택을 교환할 수 있도록 회사가 제공하는 기능을 말한다.",
            "“회원”이란 이 약관과 개인정보처리방침에 동의하고 소셜 로그인 등 회사가 정한 절차로 계정을 생성한 사람을 말한다.",
            "“제휴사”란 회사와 계약을 맺고 리워드 전환을 연동하는 대행사, 매체사 또는 그 밖의 사업자를 말한다.",
            "“원천 리워드”란 회원이 제휴 서비스에서 보유한 포인트, 캐시, 열쇠, 칩 등 명칭과 단위가 서로 다른 리워드를 말한다.",
            "“전환”이란 회원의 요청과 동의에 따라 제휴 서비스의 원천 리워드를 차감하고, 확정된 조건에 따라 CashHub 통합잔액을 적립하는 절차를 말한다.",
            "“전환 확인정보”란 전환할 원천 리워드, 적용률, 전환비용, 최종 적립예정액, 최소·최대 전환단위, 소멸기준 및 취소 가능 여부를 말한다.",
            "“통합잔액”이란 회사가 서비스 내 거래를 기록하고 상품 교환에 사용할 수 있도록 회원별 원장에 표시하는 서비스 이용 단위를 말한다.",
            "“잔액 묶음”이란 원천 출처, 전환일, 적립액, 사용액 및 소멸예정일을 구분하여 관리하는 내부 원장 단위를 말한다.",
            "“상품”이란 통합잔액을 사용하여 교환할 수 있는 모바일 상품권, 포인트 교환권 또는 그 밖의 재화·서비스를 말한다.",
            "“상품 공급사”란 회사와 계약하여 상품 목록, 발행, 발송, 상태조회, 취소 또는 재발송 기능을 제공하는 사업자를 말한다.",
          ],
        },
      ],
    },
    {
      title: "제4조 약관의 효력과 변경",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회사는 이 약관을 회원이 쉽게 확인할 수 있도록 서비스 화면에 게시한다.",
            "약관은 회원이 동의하고 회사가 가입을 승낙한 때 효력이 발생한다.",
            "회사가 약관을 변경하는 경우 적용일과 변경사유를 명시하여 적용일 7일 전부터 알린다. 회원에게 불리하거나 중요한 변경은 원칙적으로 30일 전부터 개별 알림과 서비스 공지를 함께 제공한다.",
            "회사는 법령상 별도 동의가 필요한 변경에 대하여 회원의 명시적 동의를 받는다. 단순히 서비스를 계속 사용했다는 이유만으로 법령상 필요한 동의를 받은 것으로 처리하지 않는다.",
            "회원이 변경 약관에 동의하지 않는 경우 이용계약을 해지할 수 있다. 회사는 기존 약관을 적용할 수 없는 정당한 사유가 있는 경우 법령과 본 약관에 따라 서비스 이용을 종료할 수 있다.",
          ],
        },
      ],
    },
    {
      title: "제5조 가입과 계정",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회원은 Google 등 회사가 제공하는 소셜 로그인으로 가입할 수 있다. 추가 로그인 사업자는 실제 연동과 개인정보 고지가 완료된 뒤 제공한다.",
            "회원은 본인의 계정만 사용해야 하며 계정 또는 인증수단을 양도·대여하거나 제3자에게 사용하게 해서는 안 된다.",
            "회사는 거래 안전과 부정이용 방지를 위하여 필요한 범위에서 휴대전화 인증, 연령 확인 또는 본인 확인을 요청할 수 있다.",
            "회사는 현재 만 14세 미만 아동의 법정대리인 동의 절차를 제공하지 않으므로 만 14세 미만의 가입을 제한한다. 관련 절차를 도입하는 경우 별도 고지와 동의를 거친다.",
            "타인 명의 사용, 허위정보, 비정상적인 반복가입, 시스템 우회 또는 법령 위반 목적의 가입은 거절하거나 제한할 수 있다.",
          ],
        },
      ],
    },
    {
      title: "제6조 서비스의 내용",
      blocks: [
        { kind: "paragraph", text: "회사는 다음 서비스를 제공할 수 있다." },
        {
          kind: "ordered-list",
          items: [
            "제휴 서비스에서 시작된 원천 리워드 전환",
            "전환 확인정보 제공 및 회원 동의",
            "통합잔액 적립, 조회, 사용, 보류 및 소멸예정 안내",
            "전환·사용·취소·복원·소멸 내역 조회",
            "상품 목록 조회, 교환, 발행상태 확인 및 가능한 경우 재발송",
            "서비스 알림, 고객문의 및 분쟁처리",
            "그 밖에 회사가 별도로 안내하는 기능",
          ],
        },
      ],
    },
    {
      title: "제7조 전환 신청과 성립",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회원은 원칙적으로 이용 중인 제휴 서비스의 인증된 진입점에서 전환을 시작한다.",
            "회사는 전환 확정 전에 전환 확인정보를 회원에게 표시하고 확인·동의를 받는다.",
            "제휴사별 원천 리워드의 명칭, 가치, 최소·최대 단위, 적용률 및 전환비용은 계약과 운영정책에 따라 다를 수 있다.",
            "전환은 제휴사에서 원천 리워드 차감이 확인되고 CashHub 원장에 통합잔액 적립이 완료된 때 성립한다.",
            "동일 요청의 중복처리를 막기 위하여 회사와 제휴사는 거래식별자를 사용한다.",
            "원천 리워드 차감과 통합잔액 적립 중 어느 하나가 실패하면 회사는 해당 거래를 완료로 표시하지 않고 재처리, 원천 리워드 복원 또는 통합잔액 회수 등 일관된 복구절차를 수행한다.",
          ],
        },
      ],
    },
    {
      title: "제8조 통합잔액",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "통합잔액은 서로 다른 제휴 서비스에서 전환된 금액을 합산하여 상품 교환에 사용할 수 있도록 표시한다.",
            "회원 화면에서는 합산 잔액을 보여줄 수 있으나, 회사는 정산·소멸·취소·분쟁처리를 위해 원천 출처와 잔액 묶음을 계속 보관한다.",
            "통합잔액은 예금이 아니며 이자가 발생하지 않는다. 회사가 별도로 제공한다고 명시한 경우를 제외하고 회원 간 양도, 담보 제공 또는 현금 인출은 허용되지 않는다.",
            "통합잔액에 전자금융거래법 등 관계 법령이 적용되는 경우 회사는 환급, 이용자 보호 및 거래기록 보존 등 해당 법령에서 정한 의무를 따른다.",
          ],
        },
      ],
    },
    {
      title: "제9조 전환비용과 계약상 배분",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회원에게 적용되는 전환비용이나 적용률은 전환 확정 전에 금액으로 명확히 표시한다.",
            "제휴사와 회사 사이의 정산·수익배분 비율은 별도 계약에 따른 내부 정산조건이며, 회원에게 적용되는 전환비용과 구분한다.",
            "제휴사별 비율이 변경되더라도 이미 완료된 거래에는 당시 회원이 동의한 정책 스냅샷을 적용한다.",
            "반올림 단위, 최소 전환단위 및 한도는 전환·통합잔액 운영정책과 전환 확인화면에 표시한다.",
          ],
        },
      ],
    },
    {
      title: "제10조 사용 순서와 보류",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "통합잔액 사용 시 소멸예정일이 빠른 잔액 묶음부터 차감하는 것을 원칙으로 한다.",
            "상품 교환 요청 중에는 필요한 금액을 보류할 수 있다. 교환이 완료되면 보류액을 사용 처리하고, 실패하거나 적법하게 취소되면 보류를 해제한다.",
            "시스템 오류나 중복적립이 확인된 경우 회사는 거래근거를 제시하고 잘못 적립된 잔액을 정정할 수 있다. 이미 사용되어 즉시 정정이 어려운 경우 회원에게 사유와 처리방법을 알린다.",
          ],
        },
      ],
    },
    {
      title: "제11조 유효기간과 소멸",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "통합잔액의 유효기간은 전환 완료일로부터 5년을 원칙으로 한다. 관계 법령이나 개별 전환조건에서 더 긴 기간을 정한 경우에는 그 기간을 적용한다.",
            "회사는 서비스 화면에서 소멸예정 잔액과 날짜를 확인할 수 있도록 한다.",
            "회사는 연락 가능한 회원에게 원칙적으로 소멸 30일 전과 7일 전에 알림을 제공한다.",
            "법령상 소멸이 허용되지 않거나 연장·환급 의무가 있는 잔액은 해당 법령을 우선 적용한다.",
            "장애, 분쟁 또는 회사 귀책으로 사용할 수 없었던 기간은 소멸 산정에서 제외하거나 합리적인 기간만큼 연장한다.",
          ],
        },
      ],
    },
    {
      title: "제12조 상품 교환",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회원은 상품명, 공급사, 차감금액, 유효기간, 사용처, 수령방법, 취소·환불 조건을 확인한 후 교환을 요청한다.",
            "휴대전화로 발송되는 상품은 회원이 수령번호를 정확히 입력해야 한다.",
            "회사는 상품 공급사의 API를 이용하여 상품을 발행·발송하고 상태를 조회할 수 있다.",
            "상품 발행이 실패하면 통합잔액을 확정 차감하지 않으며, 이미 차감된 경우 원장에 복원 거래를 기록한다.",
            "재발송은 상품이 유효하고 공급사가 허용하며 부정사용 우려가 없는 범위에서 제공한다.",
          ],
        },
      ],
    },
    {
      title: "제13조 전환 및 상품 교환의 취소·환불",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "전환 확정 전에는 회원이 요청을 중단할 수 있다.",
            "원천 리워드 차감과 통합잔액 적립이 모두 완료된 전환은 원칙적으로 취소할 수 없다. 다만, 중복처리, 시스템 오류, 제휴사 차감 실패 또는 법령상 취소가 필요한 경우에는 예외로 한다.",
            "상품 공급사에 발행 요청이 전달되기 전에는 교환 취소를 요청할 수 있다.",
            "발행이 완료된 모바일 상품권의 취소·환불·유효기간 연장은 상품 안내, 공급사 정책 및 관련 법령에 따른다.",
            "상품 안내에 “취소 불가”라고 표시하더라도 법령상 청약철회·환급 권리까지 제한하지 않는다.",
            "오류나 취소가 발생하면 회사는 최초 거래를 직접 수정·삭제하지 않고 취소·복원 원장을 별도로 기록한다.",
          ],
        },
      ],
    },
    {
      title: "제14조 서비스 이용 제한",
      blocks: [
        { kind: "paragraph", text: "회사는 다음 행위가 확인되거나 합리적으로 의심되는 경우 조사에 필요한 최소 범위에서 거래 또는 계정을 일시 제한할 수 있다." },
        {
          kind: "ordered-list",
          items: ["타인 계정·휴대전화번호 또는 인증수단의 무단 사용", "중복요청, 자동화 도구, 취약점 또는 오류를 이용한 부정 전환", "상품권의 불법 현금화, 재판매, 자금세탁 또는 범죄 관련 이용", "정산·세금·본인확인 의무를 회피하기 위한 거래 분할", "회사·제휴사·공급사 시스템 또는 다른 회원의 권리를 침해하는 행위"],
        },
        { kind: "paragraph", text: "회사는 긴급한 보안조치를 제외하고 제한 사유, 범위와 이의제기 방법을 회원에게 알린다." },
      ],
    },
    {
      title: "제15조 회원의 의무",
      blocks: [{ kind: "paragraph", text: "회원은 계정과 기기를 안전하게 관리하고, 거래내역 또는 상품 수령정보의 이상을 발견하면 지체 없이 회사에 알려야 한다. 회원은 문의 과정에서 주민등록번호, 카드 비밀번호 등 불필요한 민감정보를 제출해서는 안 된다." }],
    },
    {
      title: "제16조 회사의 의무",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회사는 관련 법령과 약관에 따라 서비스를 안정적으로 운영하고 개인정보와 거래정보를 보호한다.",
            "회사는 원장 직접 수정 대신 반대거래를 기록하고, 관리자 권한과 감사로그를 통해 금액 조정 과정을 추적할 수 있도록 한다.",
            "회사는 회원의 정당한 문의, 오류정정 및 분쟁처리 요청을 처리한다.",
            "회사는 고의 또는 과실로 회원에게 손해를 발생시킨 경우 관련 법령에 따라 책임을 부담한다.",
          ],
        },
      ],
    },
    {
      title: "제17조 서비스 변경과 중단",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회사는 운영 또는 기술상 필요에 따라 서비스를 변경할 수 있으며 중요한 변경은 사전에 알린다.",
            "점검, 장애, 제휴사·공급사 중단, 재난 또는 보안사고로 서비스가 일시 중단될 수 있다.",
            "긴급한 경우 사후에 알릴 수 있으며, 회사 귀책으로 회원의 확정된 거래에 오류가 생기면 복구 또는 합리적인 보상절차를 제공한다.",
          ],
        },
      ],
    },
    {
      title: "제18조 알림과 광고성 정보",
      blocks: [
        {
          kind: "ordered-list",
          items: ["거래, 보안, 약관 변경, 소멸예정 및 서비스 운영에 필요한 알림은 회원의 마케팅 수신동의와 별도로 발송할 수 있다.", "혜택·광고 등 마케팅 정보는 회원이 선택적으로 동의한 채널과 범위에서만 발송한다.", "회원은 서비스 설정에서 선택 동의를 철회할 수 있으며 철회로 기본 서비스 이용이 제한되지 않는다."],
        },
      ],
    },
    {
      title: "제19조 계약 해지와 계정 삭제",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회원은 로그인된 서비스의 계정 삭제 기능으로 이용계약 해지를 요청할 수 있다.",
            "처리 중인 전환·상품교환·분쟁 또는 법령상 확인이 필요한 거래가 있으면 회사는 필요한 처리가 끝날 때까지 삭제를 보류하고 사유를 안내할 수 있다.",
            "남은 통합잔액은 삭제 전 사용, 환급 가능 여부, 소멸예정일과 처리기한을 회원에게 안내한다. 회원에게 별도 안내 없이 탈퇴와 동시에 일괄 소멸시키지 않는다.",
            "계정 삭제 후 개인정보는 개인정보처리방침에 따라 파기하되, 거래·분쟁 등 법령상 보존할 정보는 분리보관한다.",
          ],
        },
      ],
    },
    {
      title: "제20조 지식재산권",
      blocks: [{ kind: "paragraph", text: "서비스의 프로그램, 화면, 로고, 문서 등에 관한 권리는 회사 또는 정당한 권리자에게 있다. 회원은 서비스 이용에 필요한 범위를 넘어 복제, 역설계, 재판매 또는 무단사용해서는 안 된다." }],
    },
    {
      title: "제21조 책임의 제한",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회사는 천재지변, 통신망 장애, 제휴사·공급사의 불가피한 장애 등 회사가 합리적으로 통제할 수 없는 사유로 발생한 손해에 대하여 관련 법령이 허용하는 범위에서 책임을 제한할 수 있다.",
            "회사는 회사의 고의·중대한 과실, 법령상 책임 또는 개인정보 보호의무를 일률적으로 면제하지 않는다.",
            "회원의 귀책과 회사의 귀책이 함께 있는 경우 책임은 각 원인과 기여도에 따라 판단한다.",
          ],
        },
      ],
    },
    {
      title: "제22조 문의와 분쟁처리",
      blocks: [
        {
          kind: "ordered-list",
          items: [
            "회원은 로그인 후 1:1 문의를 통해 거래내역 확인, 오류정정, 상품 재발송 가능 여부 및 분쟁처리를 요청할 수 있다.",
            "개인정보 관련 요청은 개인정보처리방침에 기재된 담당부서로 접수한다.",
            "이메일은 mediavue02@gmail.com, 고객지원 연락처는 010-7386-9363으로 접수한다.",
            "회사는 문의를 접수한 후 지체 없이 처리하고, 즉시 처리가 어려운 경우 처리상황과 예상 일정을 안내한다.",
          ],
        },
      ],
    },
    {
      title: "제23조 준거법과 관할",
      blocks: [
        {
          kind: "ordered-list",
          items: ["이 약관은 대한민국 법령에 따라 해석한다.", "회사와 회원은 분쟁 발생 시 성실히 협의한다.", "협의로 해결되지 않는 분쟁의 관할은 민사소송법 등 관계 법령에 따른다."],
        },
      ],
    },
    { title: "부칙", blocks: [{ kind: "paragraph", text: "이 약관은 2026년 7월 30일부터 시행한다." }] },
  ],
  slug: "terms-service",
  title: "CashHub 서비스 이용약관",
  version: "1.0",
} as const satisfies PublishedLegalDocument
